import { Box, Typography } from "@mui/material";
import { MEASUREMENT_MODES } from "../../utils/measurementQuestionDetect";

export default function MeasurementWorkspace({
  images = [],
  measurementMode,
  caption,
  imageSx,
}) {
  if (!images.length) return null;

  return (
    <Box sx={{ mb: 2 }}>
      {caption ? (
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.75, fontWeight: 700 }}>
          {caption}
        </Typography>
      ) : null}
      <Box
        sx={{
          p: 1.5,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1.5,
          bgcolor: "grey.50",
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            justifyContent: "center",
            alignItems: "center",
            minHeight: measurementMode ? 200 : undefined,
            overflow: "visible",
            touchAction: "none",
          }}
        >
          {images.map((src, i) => (
            <Box
              key={`${src}_${i}`}
              component="img"
              src={src}
              alt=""
              onError={(e) => {
                e.target.style.display = "none";
              }}
              sx={{
                maxWidth: "100%",
                maxHeight: 400,
                objectFit: "contain",
                borderRadius: 1,
                border: "1px solid #ddd",
                display: "block",
                position: "relative",
                zIndex: 1,
                ...imageSx,
              }}
            />
          ))}
        </Box>
      </Box>
      {measurementMode === MEASUREMENT_MODES.LENGTH ? (
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5, fontStyle: "italic" }}>
          Ruler scale is fixed on screen for practice — type the length you measure.
        </Typography>
      ) : null}
    </Box>
  );
}
